import { Component, OnInit, Input } from "@angular/core";
import {
	FormBuilder,
	FormGroup,
	FormControl,
	Validators,
} from "@angular/forms";
import { CustomerService } from "src/app/services/api/customer.service";
import { ActivatedRoute } from "@angular/router";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
	selector: "app-reviewform",
	templateUrl: "./reviewform.component.html",
	styleUrls: ["./reviewform.component.scss"],
})
export class ReviewformComponent implements OnInit {
	@Input() onClose: any = null;
	@Input() product: any = null;

	reviewForm: FormGroup;
	submitted: boolean = false;
	answerClicked: any = "Yes";

	constructor(
		private fb: FormBuilder,
		public _route: ActivatedRoute,
		public customerService: CustomerService,
		public modalRef: BsModalRef
	) {}

	ngOnInit() {
		if (this.customerService.customer) {
			let nickName = this.customerService.customer.firstname + " " + this.customerService.customer.lastname;

			this.reviewForm = this.fb.group({
				rating: [1],
				rating_option: ["", [Validators.required, Validators.min(1)]],
				title: ["na"],
				nickname: [nickName, [Validators.required, Validators.maxLength(128)]],
				detail: ["", [Validators.required, Validators.maxLength(255)]],
			});
		}
	}

	closeModal() {
		this.onClose();
	}

	/**
	 * set the start rating value
	 * @param star
	 */
	setRating(star) {
		this.reviewForm.controls.rating_option.setValue(star);
	}

	orderAgain(answer: any) {
		this.answerClicked = answer;
	}

	addReview() {
		this.submitted = true;

		if (this.answerClicked != null) {
			// Concat review detail with order again answer
			this.reviewForm.value["detail"] = this.answerClicked.concat(
				" - ",
				this.reviewForm.value["detail"]
			);
			if (!this.reviewForm.invalid) {
				let url = "/rest/entrelable/V1/lns-api/product/review/" + this.product.id + "/save";
				this.customerService.setLoader(true);
				this.customerService
				.makeRequest(url, this.reviewForm.value, "POST")
				.then((resolve) => {
					if (resolve) {
						this.customerService.toastService.add(
							"Your review for " + this.product.name + " has been saved"
						);
					}
					this.onClose(resolve);
					this.customerService.setLoader(false);
				});
			}
		} else {
			this.customerService.toastService.add(
				"Kindly give us a feedback if you'll order again",
				"danger"
			);
		}
	}

	/**
	 * return the src of the image for sart ratings
	 * @param currentStart
	 */
	getStartIcon(currentStart) {
		let s: any = parseInt(this.reviewForm.value.rating_option);
		if (s >= currentStart) {
			return "./assets/icons/star-solid.png";
		} else {
			return "./assets/icons/star-blank.png";
		}
	}
}
